import { Link } from "react-router-dom";

export const wrapInLink = (children: React.ReactNode, href: string) => {
    if (href) {
        return (
            <Link to={href} style={{ textDecoration: 'none', color: 'inherit' }}>
                {children}
            </Link>
        );
    }
    return children;
}